export const STREET_SALES_BUSINESS_ID = 'd014a201-ec56-41a5-8ffc-015348a4dcce';

export function hasStreetSalesScope(user: { businessId?: string } | null | undefined) {
  return user?.businessId === STREET_SALES_BUSINESS_ID;
}
